// extracted by mini-css-extract-plugin
export default {"JobAds":"JobsAds_JobAds__PFhw9","close_button":"JobsAds_close_button__QLDuA","ads_mod":"JobsAds_ads_mod__wtdao","fav_pop_up":"JobsAds_fav_pop_up__ulfx3"};